<template>
  <div class="garment-wrapper">
    <iframe ref="iframe" class="flex-1" :src="finalSrc" frameborder="0" allowfullscreen></iframe>
    <img class="cancel-btn" src="../../assets/common/cross.svg" @click="$emit('cancel')" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { wait } from '@/modules/utils';

// FIXME: need to enforce some restrictions?
const TARGET_ORIGIN = '*';
const STYLEBRIC_UI_PATH = process.env.VUE_APP_STYLEBRIC_UI_PATH || '';

export default {
  name: 'Garment',
  props: {
    src: String,
  },
  async mounted() {
    window.addEventListener('message', this.handleMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage, false);
  },
  methods: {
    ...mapActions('user', ['getAccessToken']),
    validateEvent(event) {
      const { source } = event;
      return source !== window;
    },
    sendMessage(message) {
      const $iframe = this.$refs.iframe;
      if (!$iframe || !$iframe.contentWindow) {
        wait(2).then(() => this.sendMessage(message));
      } else {
        const $target = $iframe.contentWindow;
        $target.postMessage(message, TARGET_ORIGIN);
      }
    },
    handleMessage(event) {
      if (!this.validateEvent(event)) return;

      const { action } = event.data;
      if (action === 'login') {
        this.startUserLogin();
      }
    },
    async startUserLogin() {
      // start user login flow and eventually come back and emit access token to iframe
      const token = await this.getAccessToken();
      if (!token) {
        this.$toasted.show(this.$i18n.t('login.login_first'));
        setTimeout(() => {
          this.$emit('login');
        }, 2500);
      } else {
        this.sendMessage({ action: 'setToken', data: token });
      }
    },
  },
  computed: {
    ...mapGetters('user', ['accessToken']),
    finalSrc() {
      if (!this.src) return '';

      const params = ['ui=full', 'logo=false', 'messages=true', 'fullscreen=true', 'cloudzet=true'];
      if (STYLEBRIC_UI_PATH) {
        params.push(`cs_ui_path=${STYLEBRIC_UI_PATH}`);
      }
      return `${this.src}?${params.join('&')}`;
    },
  },
  watch: {
    async accessToken(nv, ov) {
      if (nv && nv !== ov) {
        const token = await this.getAccessToken();
        if (token) {
          this.sendMessage({ action: 'setToken', data: token });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.garment-wrapper {
  @apply bg-white absolute top-0 left-0 w-full h-full flex flex-col justify-start content-center overflow-hidden;
}
.cancel-btn {
  @apply absolute top-0 left-0 mt-4 ml-5 cursor-pointer;
  @screen xs {
    margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
    margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
  }
  @screen md {
    @apply mt-12 mr-12;
  }
}
</style>
